import { render } from "./ProductFilter.vue?vue&type=template&id=5be78512&scoped=true&ts=true"
import script from "./ProductFilter.vue?vue&type=script&lang=ts"
export * from "./ProductFilter.vue?vue&type=script&lang=ts"

import "./ProductFilter.vue?vue&type=style&index=0&id=5be78512&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be78512"]])

export default __exports__